import styled from 'styled-components';

export const ActionMenu = styled.div`
  min-width: 120px;
  max-width: 210px;
  position: absolute;
  top: -1px;
  right: 28px;
  border: thin solid ${({ theme }) => theme.borderColor};
  background: #fff;
  color: #000;
`;
